module.exports = __webpack_public_path__ + "img/after7.87c415ea.png";